import { render, staticRenderFns } from "./CustomerAgingOverviewTable.vue?vue&type=template&id=144d0310"
import script from "./CustomerAgingOverviewTable.vue?vue&type=script&lang=ts"
export * from "./CustomerAgingOverviewTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports